import React, { useState } from 'react';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IntrusionTopology from './IntrusionTopology';

const CutsceneIntrusion = ({ narration }) => {
  const [replayKey, setReplayKey] = useState(0);

  return (
    <div className="flex flex-col items-center gap-6 px-4 py-6 w-full">
      <div className="relative w-full max-w-3xl pt-8">
        <button
          onClick={() => setReplayKey(k => k + 1)}
          title="Replay attack animation"
          className="absolute top-0 right-0 z-10 flex items-center gap-1.5 border border-cyber-dim text-cyber-sub hover:border-cyber-accent hover:text-cyber-accent text-xs tracking-widest uppercase rounded px-2 py-1 transition-colors duration-200"
        >
          <FontAwesomeIcon icon={faArrowsRotate} />
          Replay
        </button>
        <IntrusionTopology key={replayKey} />
      </div>
      <p className="text-center text-cyber-sub text-sm tracking-widest uppercase max-w-xl leading-relaxed">
        {narration}
      </p>
    </div>
  );
};

export default CutsceneIntrusion;
